module.exports = __webpack_public_path__ + "static/assets/78376db7fd249ff51136ac8f1e948827.png";